import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { applyPreviewToCard, mpfAcompanheRedesSchema } from './schema';
import type { SocialPreview } from './SocialUrlWidget';

/**
 * Formulário da barra lateral.
 *
 * Sob `withObjectBrowser` por causa do campo Capa: o `ImageWidget` do core usa
 * `openObjectBrowser` para o botão de escolher uma imagem já publicada no site.
 *
 * `onFetchPreview` entra no *field spec* do campo de URL e chega ao
 * `SocialUrlWidget` como prop — o `InlineForm` espalha o spec inteiro. É o
 * mesmo mecanismo que `PublicacoesEditais` usa para o `activeObject`.
 */
const Data = (props) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();

  const handleFetchPreview = React.useCallback(
    (slot: number, preview: SocialPreview) => {
      const next = applyPreviewToCard(slot, data, preview);
      // `applyPreviewToCard` devolve o mesmo objeto quando não há nada a
      // preencher (título e capa já escritos à mão). Sem esta guarda, um
      // clique inócuo marcaria a página como alterada.
      if (next !== data) onChangeBlock(block, next);
    },
    [block, data, onChangeBlock],
  );

  const schema = mpfAcompanheRedesSchema({
    intl,
    formData: data,
    onFetchPreview: handleFetchPreview,
  });

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        onChangeBlock(block, { ...data, [id]: value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
